import calendar from './calendar.json';
import dates from './dates.json';
import entertainment from './entertainment.json';
import future from './future.json';
import jobapplications from './jobapplications.json';
import opinions from './opinions.json';
import pastsimpleirregulars from './pastsimpleirregulars.json';
import pastsimpleregular from './pastsimpleregular.json';
import timeexpressions from './timeexpresions.json';
import tools from './tools.json';

export const VOCABULARY_M5_U1 = [
    calendar,
    dates,
    entertainment,
    future,
    jobapplications,
    opinions,
    pastsimpleirregulars,
    pastsimpleregular,
    timeexpressions,
    tools
];
   